<template>
  <div class="main" >
    <van-form 
      ref="loginForm"
      @submit="handleUserLogin"
    >
      <div class="title">欢迎登录科帕工业</div>
      <van-field
        v-model="listQuery.username"
        name="用户名"
        label="用户名"
        placeholder="请输入用户名"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="listQuery.password"
        type="password"
        name="密码"
        label="密码"
        placeholder="请输入登录密码"
        :rules="[{ required: true, message: '' }]"
      />
      <div class="botton">
        <van-button block type="info" native-type="submit">
          登 录
        </van-button>
      </div>
      //<div class="bottom">
       // <span @click="handleClickPassword">忘记密码?</span>
      //</div>
    </van-form>
    
    <van-overlay :show="loading" @click="loading = false">
      <div @click.stop>
        <van-loading type="spinner" color="#1989fa" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import { login as userLogin } from '@/api/user'

  export default {
    name: 'Login',
    components: {},
    data() {
      return {
        loading: false,
        listQuery: {
          username: 'gys',
          password: '888888'
        },
        redirect: undefined
      }
    },
    watch: {
      $route: {
        handler(route) {
          this.redirect = (route.query && route.query.redirect) || "/";
        },
        immediate: true,
      },
    },
    beforeCreate() {
      
    },
    created() {
      
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    computed: {

    },
    methods: {
      checkPermission,
      handleUserLogin() {
        let data = new FormData()
        data.append("username", this.listQuery.username)
        data.append("password", this.listQuery.password)
        userLogin(data).then(response => {
          const { data } = response
          console.log(data)
          let personType = data.data.personType
          if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '用户登录', data.message)) {
            this.$store.dispatch("user/loginSuccess", data).then(response => {
              if (personType === 0 || personType === 3) {
                this.$router.replace({ 
                  path:'/dashboard/order', 
                  query: {} ,
                }).catch(() =>{
                  
                })
              } else {
                this.$router.replace({
                  path:'/dashboard', 
                  query: {} ,
                }).catch(() =>{
                  
                })
              }
            })
          }
          if (typeof data.data === "undefined") {
            return
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickPassword() {
        showPhoneAlarm(true, 'toast', null, 2000, 20000, '找回密码', '开发中')
        console.log('开发中')
      }
    }
  }
</script>


<style scoped lang="scss">
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 4.2em;
  }
  .van-cell {
    background-color: #F8F8F8;
  }
  // 自定义样式
  .main { 
    height: 100vh;
    // background-color: #F8F8F8; 
    background-color: #2D3A4B;
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    display: flex; 
    justify-content: center; 
    align-items: center;
  }
  .title {
    margin-top: -30vh; 
    margin-bottom: 10vh;
    font-size: 7vw;
  }
  .content {
    
  }
  .botton {
    margin: 5vh 2vh 1.6vh 2vh;
    // margin-bottom: 10vh;
  }
  .bottom {
    color: #999;
    font-size: 3.6vw;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left: 4vw;
  }
</style>
